let mFontInfo:any;
export function initFontInfo(db){
    mFontInfo = db.table('fontInfo');
}

export function updateFontInfo(item){
    return mFontInfo.put(item)
}

export async function getFontInfo(id){
    return await mFontInfo.get(id);
}

export function fontInfoList(){
    return mFontInfo.toArray();
}

export function deleteFontInfo(id){
    return mFontInfo.delete(id);
}